import { V4 } from '@moleculeone/utils';

function getSVGPos(clientPos, svgElement) {
  const domPoint = new DOMPointReadOnly(clientPos[0], clientPos[1]);
  const pt = domPoint.matrixTransform(svgElement.getScreenCTM().inverse());
  return V4.vect(pt.x, pt.y);
}

export function extractMolEvent(e) {
  const target = e.target.closest('.atom-group, .bond-group, .mol-svg');
  const svg = e.target.closest('.mol-svg');
  const mol = e.target.closest('.mol');

  if (svg == null) {
    return null; // event did not originate on svgmol element
  }
  const clientPos = V4.vect(e.clientX, e.clientY);
  const pagePos = V4.vect(e.pageX, e.pageY);
  const svgPos = getSVGPos(clientPos, svg);
  const molEvent = {
    clientPos,
    svgPos,
    pagePos,
    type: e.type,
    ctrlKey: e.ctrlKey,
    altKey: e.altKey,
    shiftKey: e.shiftKey,
    metaKey: e.metaKey,
  };

  const classes = target.classList;
  if (classes.contains('atom-group')) {
    molEvent.atom = true;
    molEvent.idx = target.getAttribute('data-idx');
  } else if (classes.contains('bond-group')) {
    molEvent.bond = true;
    molEvent.idx = target.getAttribute('data-idx');
    molEvent.start = target.getAttribute('data-start');
    molEvent.end = target.getAttribute('data-end');
  } else {
    molEvent.empty = true;
  }
  if (mol !== null) {
    molEvent.mol = true;
    if (mol.attributes['data-idx']) {
      molEvent.molIdx = mol.getAttribute('data-idx');
    }
  }
  return molEvent;
}
